import {
  ISubscriptionPlanCard,
  IUserSubscriptionEntity,
  SUBSCRIPTION_PLAN,
  SUBSCRIPTION_RECURRENT,
} from 'interfaces/subscriptions';

interface IDataLayerWindow extends Window {
  dataLayer?: Record<string, unknown>[];
}

const getPlanPrice = (plan: ISubscriptionPlanCard, isYearly: boolean) => {
  return isYearly
    ? parseInt(plan.billYearly.tariffCostYearly.slice(1), 10)
    : parseInt(plan.billMonthly.tariffCostMonthly.slice(1), 10);
};

export const trackPurchase = (
  currentSubscription: IUserSubscriptionEntity,
  plansData: ISubscriptionPlanCard[],
): boolean => {
  const dataLayer = (window as IDataLayerWindow).dataLayer;

  if (!dataLayer || currentSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.FREE) {
    return false;
  }

  const storageKey = `ga_purchase_tracked_${currentSubscription.id}`;

  if (sessionStorage.getItem(storageKey)) {
    return true;
  }

  const plan =
    plansData.find((item) => item.tariff === currentSubscription.subscriptionPlan) ??
    plansData.find((item) => item.tariff === SUBSCRIPTION_PLAN.LIGHT);

  if (!plan) {
    return false;
  }

  const isYearly = currentSubscription.recurrent === SUBSCRIPTION_RECURRENT.ANNUALLY;
  const price = getPlanPrice(plan, isYearly);
  const itemVariant = isYearly ? 'Billed annually' : 'Billed monthly';
  const tariffVariant = currentSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.STANDARD ? 'standard' : 'light';
  const itemId = isYearly ? `${tariffVariant}-yearly` : `${tariffVariant}-monthly`;

  sessionStorage.setItem(storageKey, '1');

  dataLayer.push({
    event: 'purchase',
    ecommerce: {
      value: price,
      tax: 0,
      shipping: 0,
      items: [
        {
          item_name: currentSubscription.subscriptionPlan.toLowerCase(),
          item_variant: itemVariant,
          item_id: itemId,
          price,
          quantity: 1,
        },
      ],
    },
  });

  return true;
};
